export default __webpack_public_path__ + "static/Ecozohm-7d41f019e60313a0432595f08277bd54.jpg";